import { cloneElement, toChildArray } from 'preact';
import { useEffect } from 'preact/hooks';
import { buildURL } from 'Shared/fetch';

import { checkLocalStorageForODTP, identifyUser } from '../../helpers';
import store from '../../redux/store';

export const useUserEffect = (setUserDataAction, unsetUserDataAction) => {
  const { searchParams } = new URL(document.location);

  useEffect(() => {
    const loadUserData = async () => {
      const { user } = store.getState();
      if (!user?.sessionChecked) {
        const odtpEntry = Array.from(searchParams).find(([key]) => key.toLowerCase().includes('odtp'));
        let odtpParam = '';
        if (odtpEntry) {
          const [key, value] = odtpEntry;
          odtpParam = `${key}=${value}`;
          odtpParam = checkLocalStorageForODTP(odtpParam);
        }
        const response = await fetch(buildURL(`/users/user${odtpParam ? `?${odtpParam}` : ''}`), {
          credentials: 'include',
          cachePolicy: 'no-cache',
        });
        if (response.status === 200) {
          const user = await response.json();
          identifyUser(user);
          setUserDataAction(user);
        } else {
          unsetUserDataAction();
        }
      }
    };

    loadUserData();
  }, []);
};

export const mapChildProps = (children, props) => toChildArray(children).map((child) => child && cloneElement(child, props));
